var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoleChange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25993",
    "data-name": "Group 25993",
    transform: "translate(-1341.5 -11912.281)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1615",
    "data-name": "Ellipse 1615",
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    transform: "translate(1341.5 11912.281)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_004-settings",
    "data-name": "004-settings",
    d: "M8.267,3.424l-.685-.087a3.444,3.444,0,0,0-.207-.5L7.8,2.291a.542.542,0,0,0-.044-.721L7.179,1A.543.543,0,0,0,6.456.949l-.544.423a3.432,3.432,0,0,0-.5-.207L5.323.481A.546.546,0,0,0,4.782,0H3.965a.546.546,0,0,0-.542.48l-.087.685a3.392,3.392,0,0,0-.5.207L2.291.949A.542.542,0,0,0,1.57.994L1,1.568a.543.543,0,0,0-.046.724l.423.545a3.4,3.4,0,0,0-.207.5l-.684.087A.546.546,0,0,0,0,3.965v.816a.546.546,0,0,0,.48.542l.685.087a3.444,3.444,0,0,0,.207.5l-.423.545a.542.542,0,0,0,.044.721l.574.574a.544.544,0,0,0,.723.046l.545-.423a3.365,3.365,0,0,0,.5.207l.087.684a.546.546,0,0,0,.542.482h.816a.546.546,0,0,0,.542-.48l.087-.685a3.444,3.444,0,0,0,.5-.207l.545.423a.542.542,0,0,0,.721-.044l.574-.574A.543.543,0,0,0,7.8,6.456l-.423-.545a3.365,3.365,0,0,0,.207-.5l.684-.087a.546.546,0,0,0,.481-.542V3.965a.545.545,0,0,0-.48-.542ZM4.374,6.2A1.822,1.822,0,1,1,6.2,4.374,1.824,1.824,0,0,1,4.374,6.2Z",
    transform: "translate(1348.5 11919.074)",
    fill: "#172b37"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoleChange);
export default __webpack_public_path__ + "static/media/role_change.14e94c16d8de78e7b9c294491d00da6a.svg";
export { ForwardRef as ReactComponent };